// extracted by mini-css-extract-plugin
export default {"rating":"Jy-z","numberOfStars":"Ky-z","count":"Ly-z","barGraphSpacing":"My-z","barGraph":"Ny-z"};